export enum CohabitationAuthorizations {
  CohabitationQuery = 'CONVIVENZA.ANPR.QUERY',
  CohabitationAdd = 'CONVIVENZA.ANPR.ADD',
  CohabitationUpdate = 'CONVIVENZA.ANPR.UPDATE',
  CohabitationDelete = 'CONVIVENZA.ANPR.DELETE',
  StoricoConvivenza = 'CONVIVENZA.STORICO.QUERY',
}

export const CohabitationAuthorizationsList = [
  CohabitationAuthorizations.CohabitationQuery,
  CohabitationAuthorizations.CohabitationAdd,
];
